// ------------------------------------------
// ヘッダー
// ------------------------------------------
class Header {
  constructor(el) {
    this.header = document.querySelector('.' + el);
    if (!this.header) return;

    this.menu = document.querySelector('.js-menu');
    this.openBtns = document.querySelectorAll('.js-menu-open');
    this.isTop = this.header.classList.contains('is-top');
    this.isOverlay = this.header.classList.contains('is-overlay');
    this.isOpen = false;
    this.lastY = window.scrollY;
    if (this.menu) {
      this.trap = new FocusTrap(this.menu.querySelector('[role="dialog"]') || this.menu);
    }

    this.event();
  }

  event() {
    if (this.menu) {
      this.openBtns.forEach((btn) => btn.addEventListener('click', () => this.open()));
      this.menu.querySelectorAll('.js-menu-close').forEach((btn) => btn.addEventListener('click', () => this.close()));
      this.menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => this.close()));
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) this.close();
      });
    }

    window.addEventListener('scroll', () => this.onScroll(), { passive: true });
    this.updateOverlay();
    this.fixedCta();
  }

  updateOverlay() {
    if (!this.isOverlay) return;
    this.header.classList.toggle('is-scrolled', window.scrollY > 2);
  }

  fixedCta() {
    const cta = document.querySelector('.js-fixed-cta');
    const footer = document.querySelector('.js-footer');
    if (!cta || !footer) return;

    const observer = new IntersectionObserver((entries) => {
      cta.classList.toggle('is-footer', entries[0].isIntersecting);
    });
    observer.observe(footer);
  }

  onScroll() {
    if (this.isOpen) return;
    if (isScrollLocked()) return;

    const y = window.scrollY;
    const atTop = y <= 2;
    const inFv = this.isTop && !document.body.classList.contains('is-fv-passed');

    this.updateOverlay();

    // Works詳細は透過⇔通常の見た目切替のみ（隠さない）
    if (this.isOverlay || inFv) {
      this.header.classList.remove('is-hidden');
    } else if (y > this.lastY + 2 && y > this.header.offsetHeight) {
      this.header.classList.add('is-hidden');
    } else if (atTop || y < this.lastY - 2) {
      this.header.classList.remove('is-hidden');
    }

    this.lastY = y;
  }

  open() {
    if (this.isOpen) return;
    this.isOpen = true;
    this.menu.classList.add('is-open');
    this.menu.setAttribute('aria-hidden', 'false');
    this.openBtns.forEach((btn) => btn.setAttribute('aria-expanded', 'true'));
    lockBodyScroll();
    this.trap.activate(this.menu.querySelector('.c-drawer__close'));
  }

  close() {
    if (!this.isOpen) return;
    this.isOpen = false;
    this.menu.classList.remove('is-open');
    this.menu.setAttribute('aria-hidden', 'true');
    this.openBtns.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
    unlockBodyScroll();
    this.trap.deactivate();
    this.lastY = window.scrollY;
    this.updateOverlay();
  }
}
